// Get job interests list for a user  *********************
// pathname: /v1/user/job-interests
// Response is identical to /v1/user/next-jobs (NextJobData[]).
// **********************************************************
import { useSwrApi } from '@hooks/useSwrApi';

interface UseSwrJobInterestsProps {
  locale?: Locale;
  shouldFetch?: boolean;
  serverData?: ApiSchema<'NextJobData'>[];
}

/**
 * @description SWR Get job interests list for a user (merged from saved searches, job applications).
 * @param props
 */
export const useSwrJobInterests = (props: UseSwrJobInterestsProps) => {
  const { locale = 'ro', shouldFetch = true, serverData } = props;

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'NextJobData'>[]>({
    url: '/v1/user/job-interests',
    locale,
    shouldFetch,
    serverSideData: serverData,
    apiOptions: {
      dedupingInterval: 60 * 1000, // 1 minute
    },
  });

  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
